import Focus from './focus'

export default {
  install (Vue) {
    Vue.use(Focus)
  }
}
